


































































import Vue from "vue";
import EditDMS from "@/components/end_parts/EditDMS.vue";

export default Vue.extend({
  components: {
    EditDMS,
  },
  props: {
    dmsBoxParam: {
      type: Object,
      default: Object,
    },
    dmsBoxKey: {
      type: String,
      default: String,
    },
    mapType: {
      type: String,
      default: String,
    },
    dmsBoxIndex: {
      type: Number,
      default: Number,
    },
  },
  data() {
    return {
      JsonParam: Object,
    };
  },
  watch: {
    dmsBoxParam: {
      handler() {
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    reload() {
      this.JsonParam = this.dmsBoxParam[this.dmsBoxKey];
    },
    SendDMSBox() {
      this.$emit("DMSBoxEvent");
    },
    errorEvent(event: boolean) {
      this.$emit("hasError", event);
    },
  },
});
